import { LoadingButton } from '@mui/lab';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import useAsyncGoogleUnsubscribeToWebhook from '../../../../hooks/useAsyncGoogleUnsubscribeToWebhook';
import { RequestStatus } from '../../../../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../../../../store/hooks';
import { requestConfig } from '../../../../store/users';

export default function UnsubscribeFromWebhook() {
    const { classes } = useStyles();
    const dispatch = useAppDispatch();

    const { requestStatus, asyncGoogleUnsubscribeToWebhook, responseBody } =
        useAsyncGoogleUnsubscribeToWebhook();

    const handleUnsub = async () => {
        console.log('asyncGoogleSubscribeToWebhook');

        await asyncGoogleUnsubscribeToWebhook();

        dispatch(requestConfig());
    };

    return (
        <>
            <LoadingButton
                onClick={handleUnsub}
                variant="outlined"
                loading={requestStatus == RequestStatus.active}
            >
                Disable Synchronization
            </LoadingButton>
            {!!responseBody && (
                <Typography component="p" variant="body2">
                    {responseBody}
                </Typography>
            )}
        </>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({}));
